import { HelpCircle } from "lucide-react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const PasswordHintTooltip = () => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={0}>
        <TooltipTrigger>
          <HelpCircle className="h-4 w-4" />
        </TooltipTrigger>
        <TooltipContent className="max-w-[350px] text-slate-700" side="right">
          Password must contain at least 8 characters and have a mix of letters,
          numbers, and symbols.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
